/** Keep result order, stop scheduling after failure and wait for in-flight work before rejecting. */
export async function mapWithConcurrency<T, R>(items: readonly T[], concurrency: number, work: (item: T, index: number) => Promise<R>): Promise<R[]> {
  if (!Number.isInteger(concurrency) || concurrency < 1) throw new Error("Choose a positive concurrency.")
  const results: R[] = new Array(items.length)
  let next = 0, failed = false, issue: unknown
  await Promise.all(Array.from({ length: Math.min(concurrency, items.length) }, async () => {
    for (;;) {
      if (failed) return
      const index = next++
      if (index >= items.length) return
      try { results[index] = await work(items[index], index) }
      catch (error) { if (!failed) issue = error; failed = true; return }
    }
  }))
  if (failed) throw issue
  return results
}
